/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */

import { useTranslation } from 'react-i18next';
import { ExtendedMRT_ColumnDef } from '../../../Models/Marketplace.model';
import { IJobOverview } from '../../../../Jobs/Components/JobsListView/JobsListView';
import { TaskData } from '../../../../Jobs/Components/WorkTasks/WorkTasks';
import { IProfileCardProps } from '../../../../Customer/Components/ViewFacilityDetails/ViewFacilityDetails';
import { IBidList } from '../../../../Jobs/Components/JobDetails/OneTimeJobDetails';
import { IJobs } from '../../../../Jobs/Components/JobView/JobsView';
import { formatDateCell } from '../../../Utilities/Jobs.Utils';
import { ReactNode } from 'react';
import { formatUtcTime } from '../../../../../Shared/Utilities/utils';

interface IScheduleColumns {
  renderActionsCell?: (row: any) => ReactNode;
}
const ScheduleColumns = ({ renderActionsCell }: IScheduleColumns) => {
  const { t } = useTranslation(['vendor', 'tableHeader', 'altTexts', 'vendorBidCreation', 'jobAward']);

  const columns: ExtendedMRT_ColumnDef<IJobOverview | TaskData | IJobs | IBidList | IProfileCardProps>[] = [
    {
      accessorKey: 'jobName',
      header: t('jobManagement:jobName'),
      enablePinning: false,
      enableSorting: false,
      size: 10,
      enableColumnFilter: false,
      enableColumnActions: false,
      Cell: ({ renderedCellValue }) => (renderedCellValue ? renderedCellValue : '-'),
    },
    {
      accessorKey: 'scheduleName',
      header: t('jobManagement:scheduleName'),
      enablePinning: false,
      enableSorting: false,
      size: 10,
      enableColumnFilter: false,
      enableColumnActions: false,
      Cell: ({ renderedCellValue }) => (renderedCellValue ? renderedCellValue : '-'),
    },
    {
      accessorKey: 'scheduleDate',
      header: t('jobManagement:scheduleDate'),
      enableSorting: false,
      enableColumnFilter: false,
      size: 140,
      Cell: ({ cell }) => {
        return cell ? formatDateCell(cell) : '-';
      },
      enableColumnActions: false,
    },
    {
      accessorKey: 'scheduleStartTime',
      header: t('jobManagement:scheduleStartTime'),
      enableSorting: false,
      enableColumnFilter: false,
      size: 100,
      Cell: ({ renderedCellValue }) => {
        const time = String(renderedCellValue);
        return time ? formatUtcTime(time, 'Do MMM, h:mm A') : '-';
      },
      enableColumnActions: false,
    },
    {
      accessorKey: 'scheduleEndTime',
      header: t('jobManagement:scheduleEndTime'),
      enableSorting: false,
      enableColumnFilter: false,
      size: 100,
      Cell: ({ renderedCellValue }) => {
        const time = String(renderedCellValue);

        return time ? formatUtcTime(time, 'Do MMM, h:mm A') : '-';
      },
    },
    {
      accessorKey: 'employees',
      header: 'Associates',
      enableSorting: false,
      enableColumnFilter: false,
      size: 200,
      Cell: ({ renderedCellValue }) => {
        return Array.isArray(renderedCellValue)
          ? renderedCellValue.map((item: { userName: any }) => item.userName).join(', ')
          : '-';
      },
    },
    {
      header: t('tableHeader:actions'),
      enableColumnActions: false,
      enablePinning: false,
      size: 90,
      Cell: ({ row }: any) => renderActionsCell?.(row),
    },
  ];

  return columns;
};

export default ScheduleColumns;
